import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import './scss/style.scss';
import { translate } from 'react-i18next';
import { Autocomplete, TextField } from '@mui/material';
import $ from 'jquery';
import { request } from '../../config';
import StartDatePicker from '../../components/Dashboard/Decree/StartDatePicker/StartDatePicker';

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        display: 'inline-block',
        maxHeight: '90vh',
        overflow: 'auto'
    },
}));

function AddDocumentDecree(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const [files, setFiles] = React.useState([]);

    const close = (val) => {
        setOpen(false);
        props.onClose(val);
    }
    useEffect(() => {
        setOpen(props.open)
        setFiles(props.files || []);
    }, [props.open, props.files])

    const triggerFunc = (val) => {
        close(val)
        if (val) {
            props.triggerFunc(val);
        }
    }

    const saveFile = (name, type, data) => {
        if (data !== null && navigator.msSaveBlob)
            return navigator.msSaveBlob(new Blob([data], { type: type }), name);
        var a = $("<a style='display: none;'/>");
        var url = window.URL.createObjectURL(new Blob([data], { type: type }));
        a.attr("href", url);
        a.attr("download", name);
        $("body").append(a);
        a[0].click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }

    const chooseFile = (event) => {
        let newFiles = [...files];
        for (let i = 0; i < event.target.files.length; i++) {
            newFiles.push({ files: event.target.files[i], fileName: event.target.files[i].name });
        }
        setFiles(newFiles);
    }
    const chooseFileType = (index, type) => {
        let newFiles = [...files];
        newFiles[index].type = type;
        setFiles(newFiles);
    }
    const deleteFile = (index) => {
        let newFiles = [...files];
        newFiles.splice(index, 1);
        setFiles(newFiles);
    }
    const downloadFile = (index) => {
        let arrrayBuffer = files[index].files;
        saveFile(files[index].fileName, null, arrrayBuffer);
    }

    const addFiles = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let deleteInvoiceRequestBody = {
            token: localStorage.getItem('token'),
            documentId: this.state.documentId
        }
        let data = new FormData();
        data.append('reqObject', JSON.stringify(deleteInvoiceRequestBody));
        this.state.files.map(file => {
            data.append('files', file.files, file.fileName);
        });
        data.append('docTypes', this.state.files.map(item => item?.type));
        fetch(request("swift/addOrDeleteSwiftInFiles", data, "POST_FORM"))
            .then(res => res.text())
            .then((deleteInvoiceResponseJSON) => {
                const JSON = require('true-json-bigint');
                let deleteInvoiceResponse = JSON.parse(deleteInvoiceResponseJSON);
                if (deleteInvoiceResponse.status.statusCode !== 1) {
                    if (deleteInvoiceResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(deleteInvoiceResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                } else {
                    this.getInvoiceList();
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    return (
        <div>
            <Modal
                open={open}
                onClose={() => close(false)}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                classes={classes.modal}
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description">
                <Fade in={open}>
                    <div className={classes.paper}>
                        <div className="modal-sms-service">
                            <div className="modal-sms-service-head">
                                <h2>{props.t("Add document")}</h2>
                            </div>
                            <div className="dashboard-payment-container-data-section-content-container-form-input-group">
                                <div className="dashboard-payment-container-data-section-content-container-form-input-group">
                                    <div className="dashboard-salary-order-container">
                                        <div className="dashboard-salary-order-container-box flex-nowrap mt-3">
                                            <div className="dashboard-salary-order-container-box-select w-50">
                                                <label>{props.t("date")}</label>
                                                <div className="dashboard-salary-order-container-box-select-datepicker-input">
                                                    <StartDatePicker value={props.beginDate} name="beginDate" updateDate={props.updateDate} />
                                                </div>
                                            </div>
                                            <div className="dashboard-salary-order-container-box-select w-50">
                                                <label>{props.t("Amount")}</label>
                                                <TextField value={props.amount} onChange={(e) => /^\d*(\.\d{0,2})?$/.test(e.target.value) && props.updateAmount(e.target.value)} inputProps={{ maxLength: 13 }}
                                                    InputProps={{ endAdornment: " AZN" }} />
                                            </div>
                                        </div>
                                    </div>
                                    {files.length < 1 &&
                                        <div className="position-relative mx-4">
                                            <input type="text" className="dashboard-payment-container-data-section-content-container-form-input" />
                                            <div className="dashboard-payment-container-data-section-content-container-form-icon dashboard-payment-container-data-section-content-container-form-icon__choose w-100" style={{ borderStyle: 'dotted', borderRadius: '10px', background: "none", borderColor: '#D1D5DC', color: '#4A5565' }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className='mr-2'>
                                                    <path d="M8.82263 13.5013L14 8.20001" stroke="#364153" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M10.6666 3.99999L5.05731 9.72399C4.80734 9.97403 4.66692 10.3131 4.66692 10.6667C4.66692 11.0202 4.80734 11.3593 5.05731 11.6093C5.30734 11.8593 5.64642 11.9997 5.99997 11.9997C6.35352 11.9997 6.6926 11.8593 6.94264 11.6093L12.552 5.88532C13.0519 5.38525 13.3327 4.70709 13.3327 3.99999C13.3327 3.29289 13.0519 2.61473 12.552 2.11466C12.0519 1.61473 11.3737 1.33389 10.6666 1.33389C9.95953 1.33389 9.28138 1.61473 8.78131 2.11466L3.17131 7.83799C2.4211 8.5882 1.99963 9.6057 1.99963 10.6667C1.99963 11.7276 2.4211 12.7451 3.17131 13.4953C3.92151 14.2455 4.93902 14.667 5.99997 14.667C7.06093 14.667 8.07843 14.2455 8.82864 13.4953" stroke="#364153" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>{props.t('Add document')}</div>
                                            <input id="file" type="file" style={{ cursor: files.length >= 1 ? 'not-allowed' : 'pointer' }} className="dashboard-payment-container-data-section-content-container-form-input__file w-100" accept="image/jpeg,image/png,application/pdf,zip,application/zip,application/x-zip,application/x-zip-compressed,.rar,application/x-rar-compressed" multiple={false} disabled={files.length >= 1} onChange={props.chooseFile} />
                                        </div>
                                    }
                                </div>
                                {files.map((item, index) => (
                                    <div className="dashboard-file-list-transfer-abroad mt-0 mx-4">
                                        <li className="dashboard-file-item w-50" key={index}>
                                            <div className="dashboard-file-item-left">
                                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2.09375 14.6562C3.90625 16.4688 6.84375 16.4688 8.65625 14.6562C10.3438 12.9688 13.0938 10.2188 14.7812 8.53125C14.9375 8.375 14.9375 8.15625 14.7812 8L14.25 7.46875C14.0938 7.3125 13.875 7.3125 13.7188 7.46875C12.0312 9.15625 9.28125 11.9062 7.59375 13.5938C6.375 14.8125 4.375 14.8125 3.15625 13.5938C1.9375 12.375 1.9375 10.375 3.15625 9.15625L10.1875 2.125C11 1.3125 12.3125 1.3125 13.125 2.125C13.9375 2.9375 13.9375 4.25 13.125 5.0625L7.21875 10.9688C6.8125 11.375 6.15625 11.375 5.75 10.9688C5.375 10.5938 5.375 9.9375 5.75 9.53125L10.7812 4.53125C10.9375 4.375 10.9375 4.15625 10.7812 4L10.25 3.46875C10.0938 3.3125 9.875 3.3125 9.71875 3.46875L4.71875 8.46875C3.71875 9.46875 3.71875 11.0625 4.71875 12.0312C5.6875 13.0312 7.28125 13.0312 8.25 12.0312L14.1875 6.125C15.5938 4.71875 15.5938 2.46875 14.1875 1.0625C12.7812 -0.34375 10.5312 -0.34375 9.125 1.0625L2.09375 8.09375C0.28125 9.90625 0.28125 12.8438 2.09375 14.6562Z" fill="#849097" />
                                                </svg>
                                                <button type="button" className="dashboard-file-item-title" onClick={() => props.downloadFile(index)}>{item.fileName}</button>
                                            </div>
                                            <button type="button" className="dashboard-file-item-right" onClick={() => props.deleteFile(index)}>
                                                <svg className="dashboard-transfer-list-table-icon" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.375 13H9.125C9.3125 13 9.5 12.8438 9.5 12.625V5.875C9.5 5.6875 9.3125 5.5 9.125 5.5H8.375C8.15625 5.5 8 5.6875 8 5.875V12.625C8 12.8438 8.15625 13 8.375 13ZM13.5 2.5H10.9062L9.84375 0.75C9.59375 0.34375 9.03125 0 8.5625 0H5.40625C4.9375 0 4.375 0.34375 4.125 0.75L3.0625 2.5H0.5C0.21875 2.5 0 2.75 0 3V3.5C0 3.78125 0.21875 4 0.5 4H1V14.5C1 15.3438 1.65625 16 2.5 16H11.5C12.3125 16 13 15.3438 13 14.5V4H13.5C13.75 4 14 3.78125 14 3.5V3C14 2.75 13.75 2.5 13.5 2.5ZM5.34375 1.59375C5.375 1.5625 5.46875 1.5 5.5 1.5H5.53125H8.46875C8.5 1.5 8.59375 1.5625 8.625 1.59375L9.15625 2.5H4.8125L5.34375 1.59375ZM11.5 14.5H2.5V4H11.5V14.5ZM4.875 13H5.625C5.8125 13 6 12.8438 6 12.625V5.875C6 5.6875 5.8125 5.5 5.625 5.5H4.875C4.65625 5.5 4.5 5.6875 4.5 5.875V12.625C4.5 12.8438 4.65625 13 4.875 13Z" fill="#586268" />
                                                </svg>
                                            </button>
                                        </li>
                                    </div>
                                ))
                                }
                            </div>
                            <div className="modal-sms-service-buttons">
                                <button className="modal-sms-service-button-yes" onClick={() => props.triggerFunc()}>{props.t('confirm')}</button>
                                <button className="modal-sms-service-button-no" onClick={() => close()}>{props.t('close')}</button>
                            </div>
                        </div>
                    </div>
                </Fade>
            </Modal>
        </div>
    );
}

export default translate("translation")(AddDocumentDecree);